import React from 'react';

/**
 * SAM-1343 (E1 follow-up): the status filter of the building's unit table. The approved design always shows it, even when
 * every unit has the same status (then it lists that one status next to «All statuses»).
 */
export const UnitStatusFilter: React.FC<{
  statuses: string[];
  value: string;
  onChange: (value: string) => void;
  labelOf: (status: string) => string;
}> = ({ statuses, value, onChange, labelOf }) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    aria-label="Filter by status"
    style={{ height: '36px', borderRadius: '8px', border: '1px solid #E5E7EB', background: '#fff', padding: '0 10px', fontSize: '13px', color: '#374151' }}
  >
    <option value="">All statuses</option>
    {statuses.map((v) => <option key={v} value={v}>{labelOf(v)}</option>)}
  </select>
);
